export default "__VITE_ASSET__kjuVAX4l__"